<template>
  <div class="view-account container py-4 mb-5">
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-7">
        <form class="card border-0 bg-dark text-light" @submit.prevent="submit">
          <div class="card-body">
            <div class="d-flex justify-content-center mb-5">
              <image-input @pick="pickFile" :url="photo" />
            </div>

            <nav-tab v-model="nav" />

            <template v-if="nav === 'account'">
              <form-group
                id="email"
                v-model="form.email"
                :errors="errors.email"
                type="email"
                placeholder="Seu e-mail"
                label="E-mail"
                readonly
              />

              <form-group
                id="name"
                v-model="form.name"
                :errors="errors.name"
                type="text"
                placeholder="Seu nome"
                label="Nome"
              />
            </template>

            <template v-if="nav === 'profile'">
              <form-group
                placeholder="Temperamento"
                has-icon
                select
                v-model="form.temper"
                :options="temperOptions"
                class="mb-1"
                id="temper"
              >
                <template v-slot:icon>
                  <img :src="temperImage" />
                </template>
              </form-group>
              <b-form-checkbox v-model="form.allow.display_temper" class="mb-3">
                Informação visível para todos
              </b-form-checkbox>

              <form-group
                placeholder="Profissão"
                has-icon
                v-model="form.occupation"
                class="mb-1"
                id="occupation"
              >
                <template v-slot:icon>
                  <i class="fas fa-briefcase"></i>
                </template>
              </form-group>
              <b-form-checkbox
                v-model="form.allow.display_occupation"
                class="mb-3"
              >
                Informação visível para todos
              </b-form-checkbox>

              <form-group
                placeholder="WhatsApp"
                has-icon
                id="phone"
                v-model="form.phone"
                :errors="errors.phone"
                class="mb-1"
              >
                <template v-slot:icon>
                  <i class="fab fa-whatsapp"></i>
                </template>
              </form-group>
              <b-form-checkbox v-model="form.allow.display_phone" class="mb-3">
                Informação visível para todos
              </b-form-checkbox>

              <p class="mt-4 small fw-bold">Onde mora?</p>
              <div class="row">
                <div class="col-6">
                  <form-group
                    v-model="form.localization.country"
                    placeholder="País"
                    select
                    :options="countryOptions"
                    id="country"
                  />
                </div>
                <div class="col-6">
                  <form-group
                    v-model="form.localization.state"
                    placeholder="Estado"
                    :select="form.localization.country === 'BRA'"
                    :options="stateOptions"
                    id="state"
                  />
                </div>
                <div class="col-12">
                  <form-group
                    v-model="form.localization.city"
                    placeholder="Cidade"
                    id="city"
                    class="mb-1"
                  />
                </div>
              </div>
              <b-form-checkbox
                v-model="form.allow.display_location"
                class="mb-4"
              >
                Informação visível para todos
              </b-form-checkbox>

              <form-group
                placeholder="Descrição"
                textarea
                v-model="form.biography"
              />
            </template>

            <div class="text-center pt-3 px-5">
              <button
                type="submit"
                class="btn btn-primary btn-strong btn-block rounded-pill"
                :disabled="loading"
              >
                <loading :show="loading">Salvar</loading>
              </button>

              <router-link
                :to="{ name: 'account-password' }"
                type="button"
                class="btn text-light btn-strong btn-block rounded-pill mb-5"
              >
                mudar senha
              </router-link>

              <button
                type="button"
                class="btn btn-primary btn-strong btn-block rounded-pill"
                @click="profileDialog = true"
              >
                Editar perfil
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <b-modal
      v-model="profileDialog"
      hide-footer
      hide-header
      content-class="bg-workout"
    >
      <profile-dialog @close="profileDialog = false" />
    </b-modal>
  </div>
</template>

<script>
import { formFields, countries, states } from "@/functions/helpers.js";
import ProfileDialog from "@/components/workout/ProfileDialog";
import NavTab from "@/components/account/NavTab";

export default {
  components: { ProfileDialog, NavTab },
  data() {
    return {
      nav: "account",
      profileDialog: false,
      newPhoto: false,
      photo: this.$user.user.picture,
      loading: false,
      ...formFields(
        [
          "name",
          "phone",
          "email",
          "temper",
          "localization",
          "occupation",
          "biography",
          "allow"
        ],
        {
          ...this.$user.user,
          allow: this.$user.user.allow || {
            display_phone: true,
            display_location: true,
            display_occupation: true,
            display_temper: true
          },
          localization: this.$user.user.localization || {
            country: "BRA",
            state: "",
            city: ""
          }
        }
      ),
      temperOptions: [
        { id: "colerico", name: "Colérico" },
        { id: "melancolico", name: "Melancólico" },
        { id: "fleumatico", name: "Fleumático" },
        { id: "sanguineo", name: "Sanguíneo" }
      ],
      countryOptions: countries.map(c => ({ id: c[0], name: c[1] })),
      stateOptions: states.map(c => ({ id: c[0], name: c[1] }))
    };
  },
  computed: {
    temperImage() {
      const temper = this.form.temper || "todos";
      return require(`../assets/images/temperamentos/${temper}.svg`);
    }
  },
  methods: {
    pickFile(file) {
      this.newPhoto = true;
      this.photo = file;
    },
    submit() {
      if (this.loading) {
        return;
      }
      this.loading = true;

      const data = { ...this.form };
      if (this.newPhoto) {
        data.picture = this.photo;
      }

      this.$store
        .dispatch("user/update", data)
        .then(() => {
          this.$message.success("Informações atualizadas com sucesso!");
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.view-account {
  .custom-checkbox {
    display: flex;
    justify-content: flex-end;
    font-size: 12px;

    .custom-control-label {
      display: flex;
      align-items: center;

      &::before {
        border-radius: 100%;
      }
    }
  }
}
</style>
